import { useState } from 'react';
import Button from '@mui/material/Button';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AiGenerateDialog from './AiGenerateDialog';
import { aiTokens } from './aiGeneratorTokens';
import { useTranslation } from '../../i18n/useTranslation';

export default function AiGenerateButton() {
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        startIcon={<AutoAwesomeIcon />}
        sx={{
          color: aiTokens.accent,
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { background: aiTokens.accentSoft },
        }}
      >
        {t('workflow.ai.button')}
      </Button>
      <AiGenerateDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
